import { NgClass } from '@angular/common';
import { Component, Input, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCard, MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";

@Component({
  selector: 'app-aluno-card',
  imports: [
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    NgClass
  ],
  templateUrl: './aluno-card.html',
  styleUrls: ['./aluno-card.scss']
})
export class AlunoCard {
  @Input() nome: any;
  @Input() turma: any;
  @Input() tipoDescricao: any;
  @Input() periodo: any;
  @Input() responsavel: any;
  @Input() statusFinanceiro: any;
  @Input() frequencia: any;


  textoDescricao() {
    if(this.tipoDescricao === 'Matriculado' || this.tipoDescricao === 'Remanejado' || this.tipoDescricao === 'Transferido') {
      return this.tipoDescricao;
    }else if(this.tipoDescricao === 'Pre-Matricula') {
      return 'Pré-Matrícula';
    }else if(this.tipoDescricao === 'Matricula Cancelada') {
      return 'Matrícula Cancelada';
    }
  }

  textoStatusPagamento() {
    if(this.statusFinanceiro === 'Rematricula Paga') {
      return 'Rematrícula Paga';
    } else if(this.statusFinanceiro === 'Erro no Pagamento da Rematricula') {
      return 'Erro no Pagamento da Rematrícula';
    } else {
      return this.statusFinanceiro;
    }
  }
}
